// extracted by mini-css-extract-plugin
export default {"infoBlock":"ConditionСreditInfo_infoBlock__Q+URH","infoItem":"ConditionСreditInfo_infoItem__04SiL"};